<template>
  <b-card :title="titleDate" class="add-publishing" style="height:100vh">
    <b-form-group
      id="input-group-1"
      label-for="input-1"
      description="Search public and private directories"
    >
      <b-form-input
        id="input-1"
        v-model="search"
        type="search"
        placeholder="Search ... "
      />
    </b-form-group>
    <hr />
    <b-form-group
      id="fieldset-1"
      label-for="input-1"
      valid-feedback="Thank you!"
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
      <img
        v-if="contact.imgURL"
        :src="contact.imgURL"
        style="height: 150px; border: solid; border-width: thin; border-radius: 0px; object-fit:cover"
        :alt="`${contact.phone} cover`"
      />
      <image-upload
        v-else
        ref="image-upload"
        :img-upload-idx="idx"
        img-upload-type="photo"
        :storage-path="storagePath"
        :max-image="1"
        :show-edit="true"
        :show-delete="true"
        style="margin-left: 50px; margin-right: 50px;"
        @img-uploaded-url="handleImgUploadedURL"
      />
    </b-form-group>
    <div class="optional2">
      <div class="toggler " @click="handleToggleCompany">
        <div class="slider" :class="`${isCompany ? 'btns' : ''}`" />
      </div>
      <p>
        a company?
        <span id="popover-target-1">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
              fill="#B3C2CB"
            />
            <path
              d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
        <b-popover
          target="popover-target-1"
          id="popover-target-2"
          triggers="click"
          placement="bottom"
          class="info_popup"
        >
          (i) our system will autmatically associate the calls with the
          companies and their employees
        </b-popover>
      </p>
    </div>
    <template v-if="isCompany">
      <b-form-group
        id="input-group-1"
        label="Company Name:"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="contact.company.name"
          type="text"
          placeholder="Kepro"
        />
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Company Contact:"
        label-for="input-1"
        description="enter their fullname"
      >
        <b-form-input
          id="input-1"
          v-model="contact.company.contact"
          type="text"
          placeholder="Kepro"
        />
      </b-form-group>
    </template>
    <template v-else>
      <b-form-group id="input-group-1" label="First name:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="contact.firstname"
          type="text"
          placeholder="Orlando"
        />
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Last name:"
        label-for="input-1"
        description="middle initial goes with first name"
      >
        <b-form-input
          id="input-1"
          v-model="contact.lastname"
          type="text"
          placeholder="Jewell"
        />
      </b-form-group>
    </template>
    <b-form-group id="input-group-1" label="Phone:" label-for="input-1">
      <the-mask
        :mask="['+1 (###) ###-####', '##.###.###/####-##']"
        type="tel"
        v-model="contact.phone"
        placeholder="(310) 621-4068 "
      />
      <b-form-input
        v-if="false"
        id="input-1"
        v-model="contact.phone"
        type="tel"
        v-mask="'+1 (###) ###-####'"
        placeholder="(310) 621-4068 "
      />
    </b-form-group>
    <b-form-group id="input-group-1" label="Email:" label-for="input-1">
      <b-form-input
        id="input-1"
        v-model="contact.email"
        type="email"
        placeholder="orlando@ponyengine.com "
      />
    </b-form-group>
    <hr />
    <b-form-group id="input-group-1" label="Address:" label-for="input-1">
      <b-form-input
        id="input-1"
        v-model="contact.address.address1"
        type="email"
        placeholder="1385 Boulevard"
      />
    </b-form-group>
    <b-form-group
      id="input-group-1"
      label="Address 2:"
      description="This is teh second line of the address"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="contact.address.address2"
        type="email"
        placeholder="PO Box/ Number"
      />
    </b-form-group>
    <b-form-group id="input-group-1" label="City:" label-for="input-1">
      <b-form-input
        id="input-1"
        v-model="contact.address.city"
        type="email"
        placeholder="Athens"
      />
    </b-form-group>
    <b-form-group
      id="input-group-1"
      label="State:"
      description="State, Territory or Providence"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="contact.address.state"
        type="email"
        placeholder="Georgia"
      />
    </b-form-group>
    <b-form-group id="input-group-1" label="Zip:" label-for="input-1">
      <b-form-input
        id="input-1"
        v-model="contact.address.zip"
        type="zip"
        placeholder="30605"
      />
    </b-form-group>
    <b-form-group id="input-group-1" label="Website:" label-for="input-1">
      <b-form-input
        id="input-1"
        v-model="contact.url"
        type="tel"
        placeholder="https://www.ponyengine.com"
        required
      />
    </b-form-group>
    <b-icon
      icon="file-plus"
      variant="primary"
      scale="1"
      @click="handleAddNoteTogggle"
      style="cursor:pointer;"
    />
    <label v-if="addNote"> Add Notes</label>
    <b-form-group v-if="addNote" id="input-group-1" label-for="input-1">
      <transition name="fadeHeight" mode="out-in">
        <editor
          id="textarea-default"
          v-show="true"
          @input="input"
          :clear="clear"
          :content="contact.note"
          @resetClear="resetClear"
        />
      </transition>
    </b-form-group>
    <div style="padding-top: 20px;">
      <button class="btn-add-contact" @click="handleAddContactClick">
        Add Contact
      </button>
    </div>
    <b-card v-if="!production" class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ contact }}</pre>
    </b-card>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import TheMask from "vue-the-mask/src/component";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
export default {
  name: "CallLog_ContactsFormCard",
  mixins: [UploadImage],
  components: {
    ImageUpload,
    Editor,
    TheMask
  },
  props: {},
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData",
      user: "user/user",
      profile: "user/profile"
    }),
    state() {
      return true;
      return this.contact.phone.length >= 4;
    },
    invalidFeedback() {
      if (this.contact && this.contact.phone.length > 0) {
        return "Please enter a phone number.";
      }
      return "Please enter something.";
    },
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    },
    titleDate() {
      return ""; //this.contact._created_at;
    }
  },
  mounted() {
    //@Todo move to a method that can be called
    this.contact._created_at = new Date();
    let createdBy = this.contact._created_by;
    createdBy.uid = this.user.id ? this.user.id : "XTETE";
    createdBy.name = `${this.profile.firstname} ${this.profile.lastname}`;
    createdBy.imgURL = this.profile.imgURL;
    createdBy.relation = "Uncle";
  },
  methods: {
    /*INTERNALS */
    handleToggleCompany(toggleInput) {
      //@TODO Imorove this

      this.isCompany = !this.isCompany;
      document.querySelector(".toggler").classList.toggle("bg");
      document.querySelector(".slider").classList.toggle("btns");
    },
    handleImgUploadedURL(idx, url) {
      this.contact.imgURL = url;
      this.docs.push(url);
    },
    resetForm() {
      this.item = this.image;
      this.activeIndex = null;
    },
    handleAddNoteTogggle() {
      this.addNote = !this.addNote;
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.contact.note = val.content;
    },
    /*EMITTERS*/
    handleAddContactClick() {
      this.$emit("add-contact-click", this.contact);
    },
    /*NOT NEEDED*/
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    }
  },
  data() {
    return {
      isCompany: true,
      production: true,
      idx: 0,
      docs: [],
      addNote: false,
      msgs: [
        "A photo is worth a thousand words",
        "A Photo is a memory saved",
        "Nice Photo"
      ],
      storagePath: "app_call_log_contacts",
      clear: "",
      search: "",
      name: "",
      contact: {
        _created_at: 1234,
        imgURL: "",
        firstname: "",
        lastname: "",
        email: "", //@ToDo:emails:[{}], V0.6
        phone: "", //@ToDo: phones:[{}], V0.6
        note: "",
        docs: [],
        address: {
          address1: "",
          address2: "",
          city: "",
          zip: ""
        },
        company: {
          name: "",
          contact: "" //@ToDo- Contacts
        },
        _created_by: {
          uid: "",
          name: "",
          imgURL: "",
          relation: ""
        }
      },
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.btn-add-contact {
  cursor: pointer;
  background: var(--theme-color);
  border-radius: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;
  color: #fff;
  border: none;
  height: 50px;
  width: 100%;
  margin-bottom: 25px;
}
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
.black-placeholder::-webkit-input-placeholder {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.optional2 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;

    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
